import React from "react"
import {useImage} from '../hooks/useImage'
import * as styles from "./intro.module.scss"
import Disclaimer from './disclaimer'

export default function Intro(props) {
    return (
        <section>
            <h1 dangerouslySetInnerHTML={{__html: props.headline }}  className={styles.title} />
            <div>
                <p className={styles.text} dangerouslySetInnerHTML={{__html: props.text}} ></p>
            </div>
            <div className={styles.disclaimer}>
                <Disclaimer text={props.source} />
            </div>
        </section>
    )
} 